module.exports = __webpack_public_path__ + "img/receipt.ef2e4262.svg";